import { useIntl } from "react-intl";

import { accountCss, memberCss, realNameCss } from "./index.styles";

import { emphasizeMatchedText } from "~/client/components/search/emphasizeMatchedText";
import type { MemberItem } from "~/client/components/search/hooks/useMemberSearchResult";
import { ListItem } from "~/client/components/search/SearchBoxDropdown/ListItem";
import { ListItemLink } from "~/client/components/search/SearchBoxDropdown/ListItemLink";
import { UserAvatar } from "~/client/components/shared/UserAvatar";
import { friendlyUserPath } from "~/client/generated/routes";

interface Props {
  item: MemberItem;
  isSelected: boolean;
  query: string;
}
export const Member: React.FC<Props> = ({ item, isSelected, query }) => {
  const intl = useIntl();

  const realName = item.realName
    ? emphasizeMatchedText(item.realName, query)
    : intl.formatMessage({ id: "profile.nouns.realNameEmpty" });

  return (
    <ListItem isSelected={isSelected}>
      <ListItemLink to={friendlyUserPath(item.account)}>
        <div css={memberCss}>
          <UserAvatar
            user={{ account: item.account, avatar1x: item.avatar1x, avatar2x: item.avatar2x }}
            size="medium"
            isLink={false}
          />
          <div>
            <p dangerouslySetInnerHTML={{ __html: realName }} css={realNameCss} />
            <p
              css={accountCss}
              dangerouslySetInnerHTML={{ __html: `@${emphasizeMatchedText(item.account, query)}` }}
            ></p>
          </div>
        </div>
      </ListItemLink>
    </ListItem>
  );
};
